<template>
    <q-page padding>
        <q-tabs v-model="tab" color="white" text-color="primary" underline-color="primary" class="shadow-1 bg-white" align="justify">
            <q-tab slot="title" name="trainings" :label="$t('online')" icon="fal fa-globe" />
            <q-route-tab slot="title" name="presential" :label="$t(title_presential)" icon="fal fa-users-class" :to="{name: 'presential'}" v-if="hasPresential" />

            <q-tab-pane name="trainings" class="q-px-md q-pb-xl q-mt-md">
                <div class="row gutter-md">
                    <div :class="filterClass">
                        <filter-courses @changeFilter="changeFilter" />
                    </div>

                    <div :class="contentClass" style="min-height: 700px;">
                        <div class="col-12 desktop-only q-mb-lg" v-if="banners.length > 0">
                            <q-carousel class="text-white" height="200px" infinite autoplay>
                                <q-carousel-slide :img-src="banner.image_desktop" v-for="(banner, index) in banners" :key="index" />
                            </q-carousel>
                        </div>

                        <div class="col-12 mobile-only q-mb-lg" v-if="banners.length > 0 && showBanner">
                            <q-carousel class="text-white" :height="`${getHeight}px`" infinite autoplay>
                                <q-carousel-slide :img-src="banner.image_mobile" v-for="(banner, index) in banners" :key="index" />
                            </q-carousel>
                        </div>

                        <q-infinite-scroll :handler="loadCourses" :offset="10" ref="course_scroll">
                            <div class="row gutter-md">
                                <div class="col-xs-12 col-sm-12" v-for="(course, index) in courses" :key="index">
                                    <card-desktop :course="course" v-if="$q.platform.is.desktop" :key="course.id" @clickLike="clickLike" @clickStars="clickStars" @clickFavorite="clickFavorite" @showCertificate="showCertificate" />

                                    <card-mobile :course="course" v-if="$q.platform.is.mobile" :key="course.id" @clickLike="clickLike" @clickStars="clickStars" @clickFavorite="clickFavorite" @showCertificate="showCertificate" />
                                </div>

                                <div class="col-xs-12 col-sm-12" v-if="courses.length == 0 && !has_next_page">
                                    <q-card>
                                        <q-card-title>
                                            {{ $t('no_course_found') }}
                                        </q-card-title>
                                        <q-card-separator />
                                        <q-card-main v-if="this.search || this.selected_areas.length > 0 || this.favorite != 'all' || this.progress != 'all'">
                                            {{ $t('searched_term_returned_no_results') }}
                                        </q-card-main>
                                        <q-card-main v-else>
                                            {{ $t('there_are_no_courses_avaliable_at_the_moment') }}
                                        </q-card-main>
                                    </q-card>
                                </div>
                            </div>

                            <div class="text-center q-mt-xl">
                                <q-spinner-dots slot="message" :size="40" v-if="has_next_page"></q-spinner-dots>
                            </div>
                        </q-infinite-scroll>
                    </div>
                </div>
            </q-tab-pane>
        </q-tabs>

        <modal-stars :show="show_modal" :course="course" @hideModal="hideModal" />

        <certificate :show="show_certificate" :data="certificate_data" :certificate="certificate" @hideCertificate="hideCertificate" />
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import Filter from 'components/courses/Filter'
import CardDesktop from 'components/courses/CardDesktop'
import CardMobile from 'components/courses/CardMobile'
import ModalStars from 'components/courses/ModalStars'
import Certificate from 'components/Certificate'
import { date } from 'quasar'
const { formatDate } = date

export default {
    i18nOptions: { namespaces: [ 'custom', 'common', 'courses', 'training', 'discussions'] },

    data() {
        return {
            tab: 'trainings',
            courses: [],
            course: [],
            show_modal: false,
            certificate_data: [],
            show_certificate: false,
            banners: [],
            page: 1,
            has_next_page: true,
            certificate: {}
        }
    },

    components: {
        'filter-courses': Filter,
        'card-desktop': CardDesktop,
        'card-mobile': CardMobile,
        'modal-stars': ModalStars,
        'certificate': Certificate
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            reload_content: 'common/reload_content',
            clients: 'params/clients',
            id_user_client_selected: 'common/id_user_client_selected',
            search: 'courses/search',
            progress: 'courses/progress',
            favorite: 'courses/favorite',
            selected_areas: 'courses/selected_areas',
            selected_groups: 'courses/selected_groups',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        showBanner() {
            let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
            if(obj) {
                if(obj.show_banner_mobile) return true
                else return false
            }
            else return true
        },

        getHeight() {
            let height = (180 / 323) * this.$q.screen.width
            return parseInt(height)
        },

        title_presential(){
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
				if (obj) {
					return obj.title_presential == '' ? 'presential' : obj.title_presential
				}
			}
        },

		title_trainings(){
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
				if (obj) {
					return obj.title_trainings == "" ? 'trainings' : obj.title_trainings
				}
			}
        },

        filterClass() {
            if (this.$q.platform.is.ipad) return 'col-12'
            else return 'col-xs-12 col-sm-3'
        },

        contentClass() {
            if (this.$q.platform.is.ipad) return 'col-12'
            else return 'col-xs-12 col-sm-9'
        },

        hasPresential() {
            if (this.id_user_client_selected) {
                let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
                if (obj) {
                    return obj.has_presential
                }
            }

            return false
        }
    },

    methods: {
        loadCourses(index, done) {
            if (this.has_next_page) {
                let data = {
                    "page_size": 5,
                    "page": this.page,
                    "search": this.search,
                    "favorited": this.favorite === 'all' ? false : true,
                    "areas": this.selected_areas,
                    "user_groups": this.selected_groups
                }

                if (this.progress !== 'all') data.progress = this.progress

                this.$axios.get('/etraining_courses/group_trainings/?' + this.$qs.stringify(data, { arrayFormat: 'repeat' }), this.getHeader)
                .then(response => {
                    response.data.results.map((course) => {
                        let image_small = ''
                        let image_thumb = ''

                        let obj = course.group_training_images.find((obj) => { return obj.name === 'thumbnail' })
                        if (obj) image_thumb = obj.image_url

                        obj = course.group_training_images.find((obj) => { return obj.name === 'small' })
                        if (obj) image_small = obj.image_url

                        this.courses.push({
                            id: course.id,
                            image_thumb: image_thumb,
                            image_small: image_small,
                            areas: course.areas,
                            group_training_user_result_status: course.group_training_user_result_status,
                            group_training_user_result_percent: course.group_training_user_result_percent,
                            liked: course.liked,
                            workload: course.workload,
                            likes: course.likes ? course.likes : "0",
                            qty_modules: course.qty_modules ? course.qty_modules : "0",
                            qty_tests: course.qty_tests ? course.qty_tests : "0",
                            stars: course.avg_stars ? parseInt(course.avg_stars) : "0",
                            stars_rating: course.avg_stars,
                            starred: course.starred,
                            tags: course.tags,
                            title: course.title,
                            description: course.description,
                            user_groups: course.user_groups,
                            group_training_type: course.group_training_type,
                            score: course.score ? course.score : "0",
                            qty_materials: course.qty_materials ? course.qty_materials : "0",
                            user_progress: parseInt(course.user_progress),
                            user_progress_string: course.user_progress_string ? course.user_progress_string : "0",
                            liked: course.liked,
                            favorited: course.favorited,
                            is_open: course.is_open,
                            group_training_user_result_date: date.formatDate(course.group_training_user_result_date, 'DD/MM/YYYY')
                        })
                    })

                    if (!response.data.next) this.has_next_page = false
                    else this.page++
                })
                .catch(e => {
                    console.log(e)
                })
                .finally(() => {
                    done()
                })
            }
        },

        changeFilter() {
            this.has_next_page = true
            this.courses = []
            this.page = 1

            if (this.$refs.course_scroll) {
                this.$refs.course_scroll.stop()
                this.$refs.course_scroll.resume()
                this.$refs.course_scroll.loadMore()
            }
        },

        fetchAll() {
            this.$q.loading.show()

            this.$axios.all([this.fetchLists(), this.fetchBanners()])
            .then(this.$axios.spread((lists, banners) => {
                this.$store.dispatch('site_lists/SET_LISTS', [lists.data])

                banners.data.map((banner) => {
                    this.banners.push(banner)
                })

                this.$q.loading.hide()
            }))
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        fetchLists() {
            return this.$axios.get('/accounts/get_site_registration_lists/', this.getHeader)
        },

        fetchBanners() {
            return this.$axios.get('/etraining_banners/banners/get_banner_by_type/?banner_type=1', this.getHeader)
        },

        clickLike(id) {
            let obj = this.courses.find((obj) => { return obj.id === id })

            if (obj) {
                if (obj.liked) obj.likes--
                else if (!obj.liked) obj.likes++

                obj.liked = !obj.liked
            }

            let fd = new FormData()

            this.$axios.post(`/etraining_courses/group_training/${id}/like_group_training/`, fd, this.getHeader)
            .then(response => {
                obj.likes = response.data.likes
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        clickFavorite(id) {
            let obj = this.courses.find((obj) => { return obj.id === id })

            if (obj) {
                obj.favorited = !obj.favorited
            }

            let fd = new FormData()

            this.$axios.post(`/etraining_courses/group_training/${id}/set_group_training_user_favorite/`, fd, this.getHeader)
            .then(response => {
                obj.favorited = response.data.favorited
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        clickStars(id) {
            let obj = this.courses.find((obj) => { return obj.id === id })

            if (obj) {
                this.course = obj
                this.show_modal = true
            }
        },

        hideModal(type) {
            if (type == 'commented') {
                this.course.starred = true
            }
            this.show_modal = false
        },

        showCertificate(id) {
            let obj = this.courses.find((obj) => { return obj.id === id })

            this.$q.loading.show()

            this.$axios.get(`/etraining_courses/group_training/${id}/get_group_training_user_result_certificate/`, this.getHeader)
            .then(response => {
                this.certificate = { group_training_title: obj.title }
                this.certificate_data = response.data
                this.show_certificate = true
                this.$q.loading.hide()
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        hideCertificate() {
            this.show_certificate = false
            this.certificate_data = []
        }
    },

    watch: {
        reload_content: function() {
			this.fetchAll()
			this.changeFilter()
        }
    },

    created() {
        this.fetchAll()
    }
}
</script>

<style lang="stylus" scoped>
p
    margin 0 0 10px

.training-thumb
    width 90%
    height auto
    border-radius 10px
</style>
